import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const ChipToggle = forwardRef(({
 onClick, className, children, filterActive,
}, ref) => {
  const filteredClasses = (className || '').split(' ').filter((c) => c !== 'dropdown-toggle');

  return (
    <button
      type="button"
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
      className={classnames(
        'btn d-flex align-items-center gap-2 shadow-none paragraph-sm fw-medium px-3 py-2',
        filterActive
          ? 'bg-primary-10 border border-primary-70 text-primary-70 rounded-2 chip-toggle-active'
          : 'btn-outline-secondary border-neutral-20',
        filteredClasses,
      )}
    >
      {children}
    </button>
  );
});

ChipToggle.displayName = 'ChipToggle';

ChipToggle.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
  filterActive: PropTypes.bool,
};

export default ChipToggle;
